import { useEffect, useState } from "react";
import instance from "./api";

export default function GetLink({ href, children, target = "_blank", rel = "noopener noreferrer" }) {
    const [url, setUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    const token = localStorage.getItem("token");

    useEffect(() => {
        const fetchLink = async () => {
            setLoading(true);
            try {
                const response = await instance.get(
                    `S3Image/${token ? "getSignedImage" : "getSignedImagePublic"}?image=${href}`
                );
                setUrl(response.data.image);
            } catch (error) {
                console.error("Error fetching link:", error);
            } finally {
                setLoading(false);
            }
        };

        if (href) {
            fetchLink();
        }
    }, [href, token]);

    return (
        <>
            {url && (
                <a href={url} target={target} rel={rel}>
                    {children}
                </a>
            )}
        </>
    );
}
